import Button from "components/Button";
import Label from "components/Label";
import Media from "components/Media";
import Image from "next/image";
import React, { FC } from "react";
import { BsFillCheckCircleFill as Check } from "react-icons/bs";

import { useRouter } from "next/router";
import GrowYourBusinessImg from "../../../../../../../public/grow-your-business.png";
import GrowYourBusinessImgResponsive from "../../../../../../../public/grow-your-business-responsive.png";
import UpcomingProjects from "../../../../../../../public/upcoming-projects.svg";

import { pros } from "./constants";
import styles from "./styles.module.scss";

const GrowYourBusiness: FC = () => {
  const router = useRouter();
  return (
    <>
      <div className={styles.img}>
        <Media at={["desktop"]}>
          <Image src={GrowYourBusinessImg} />
        </Media>
        <Media at={["responsive"]}>
          <Image src={GrowYourBusinessImgResponsive} />
        </Media>
        <UpcomingProjects className={styles.upcomingProjects} />
      </div>
      <div className={styles.information}>
        <Label className={styles.title} variant="h3-centered" color="primary">
          Grow your business in your sleep
        </Label>
        <div className={styles.pros}>
          {pros.map((pro) => (
            <div key={pro} className={styles.pro}>
              <Check className={styles.check} />
              <Label variant="s3" color="primary">
                {pro}
              </Label>
            </div>
          ))}
        </div>
        <Button
          onClick={() => {
            router.push("/vendors/#form");
          }}
          variant="secondary"
          className={styles.signUp}
        >
          Sign up now
        </Button>
      </div>
    </>
  );
};

export default GrowYourBusiness;
